import { render, staticRenderFns } from "./Haber.vue?vue&type=template&id=9cc3ee66&scoped=true&"
import script from "./Haber.vue?vue&type=script&lang=js&"
export * from "./Haber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc3ee66",
  null
  
)

export default component.exports